import styled from 'styled-components';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import { colors, fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import query from 'syf-component-library/const/mediaQueries';
export const DetailsContainer = styled(Inset) `
  display: flex;
  flex-direction: column;
  max-width: 672px;
  margin: auto;
  width: 90%;
`;
export const TitleContainer = styled(Body) `
  font-weight: ${fontWeights.light};
  padding-bottom: ${spacing.medium}px;
  border-bottom: solid 1px ${colors.lightGrey};
  font-size: ${fontSizes.medium}px;
`;
export const DueDateContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media ${query.lessThanMedium} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
export const IconSection = styled.div `
  display: flex;
  width: 75%;
  align-items: center;
  @media ${query.lessThanMedium} {
    width: 100%;
  }
  @media ${query.lessThanSmall} {
    align-items: flex-start;
  }
`;
export const DateSection = styled(Body) `
  font-weight: ${fontWeights.bold};
  width: 25%;
  @media ${query.lessThanMedium} {
    padding-left: ${spacing.xlarge}px;
    width: 100%;
  }
`;
